import React from "react"
import FilterBar from "../Components/filterBar"

const PropertyFilterBar = ({ propertiesOfOrg, selectedProperties, selectedCampaigns, campaignsForDropDown, monthRange, subOrgDetails, handleChangeProperty, handleChangeCampaigns, handleMonthRange, classes, status, handleStatusChange, statusOption, children, labelKey }) => {

  const getCustomLabelForProperties = (selected, count, name, open) => {
    if (selectedProperties.length == 0) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Property</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{selectedProperties.length < 2 ? "Property" : "Properties"} ({selectedProperties.length})</div>
  }

  const getCustomLabelForCampaigns = (selected, count, name, open) => {
    if (selectedCampaigns.length == 0) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Campaign</div>
    }
    let campaignsIds = [];
    for (var i = 0; i < selectedCampaigns.length; i++) {
      campaignsIds = [...campaignsIds, ...selectedCampaigns[i].list]
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{campaignsIds.length < 2 ? "Campaign" : "Campaigns"} ({campaignsIds.length})</div>
  }

  const getCustomLabelForStatus = (selected, count, name, open) => {
    if (!name) {
      return <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>Status</div>
    }
    return <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{labelKey} ({name})</div>
  }


  return (
    <FilterBar
      firstFilterData={{
        type: "selector",
        optionValue: propertiesOfOrg,
        placeholder: "Property",
        searchPlaceHolder: "Enter property name here...",
        onChange: handleChangeProperty,
        multiple: true,
        singleSelect: false,
        value: selectedProperties,
        selectAllText: "Select all properties",
        getCustomLabel: getCustomLabelForProperties
      }}
      secondFilterData={{
        type: "dateRange",
        position: "left",
        value: monthRange,
        handleApply: handleMonthRange,
        timezoneOffset: subOrgDetails.timezoneOffset
      }}
      thirdFilterData={{
        type: "selector",
        optionValue: campaignsForDropDown,
        placeholder: "Campaign",
        searchPlaceHolder: "Enter campaign name here...",
        onChange: handleChangeCampaigns,
        multiple: true,
        groupBy: true,
        value: selectedCampaigns,
        selectAllText: "Select all Campaigns",
        getCustomLabel: getCustomLabelForCampaigns
      }}
      fourthFilterData={{
        type: "selector",
        optionValue: statusOption,
        onChange: handleStatusChange,
        singleSelect: true,
        value: status,
        getCustomLabel: getCustomLabelForStatus,
        disableSearch: true,
        disableAllSelect: true,
        height: 145,
        width: 150,
      }}
    >
      {children}
    </FilterBar>
  )

}
export default (PropertyFilterBar)